import type ModalConversationInterceptorService from '../../modals/modal-conversation-interceptor.service';

export class RecordInterceptorRegistrar {

    constructor(private modalConversationInterceptor: ModalConversationInterceptorService) {
    }

    public register() {
        // MERGING
        this.modalConversationInterceptor.registerFieldEnablingConfirmationDialogFromExceptionHandler('SourceFieldsNotInTargetFondRecordMergeException');
        this.modalConversationInterceptor.registerFieldEnablingMarkdownedConfirmationDialogFromExceptionHandler('ContinuableUniqueRecordConstraintViolationException');
        this.modalConversationInterceptor.registerFieldEnablingMarkdownedConfirmationDialogFromExceptionHandler('ContinuableReferencingRecordPresentConstraintViolationException');
    }

}
